import { createRouter, createWebHistory } from 'vue-router';
  import * as utils from "@/utils";
  import ROUTER_0J3316 from "@/views/router_0J3316.vue"

const routes = [{
      path: '/m',
      name: 'm',
      component: () => import('@/views/router_0N9I59.vue')
      },{
      path: '/',
      name: 'index',
      component: ROUTER_0J3316
    },{
    path: "/:catchAll(.*)",
    redirect: "/",
  }];

const router = createRouter({
  history: createWebHistory("/pnstf02"),
  routes
});

// 路由地址访问跳转
let isFirstVisit = true;
router.beforeEach((to, from, next) => {
  if (isFirstVisit) {
    isFirstVisit = false;
    if (to.path == '/') {
      let linkRouter = utils.getUrlParams('toRouter');
      if (linkRouter) {
        next({
          path: `/${linkRouter}`,
          query: utils.getUrlParamObj(),
        });
        return;
      }
    }
  }
  next();
});


export default router;
